export const FETCH_STOCK = 'FETCH_STOCK';
export const FETCH_STOCK_SUCCESS = 'FETCH_STOCK_SUCCESS';
export const FETCH_STOCK_FAIL = 'FETCH_STOCK_FAIL';

export const FETCH_STOCK_OPTIONS = 'FETCH_STOCK_OPTIONS';
export const FETCH_STOCK_OPTIONS_SUCCESS = 'FETCH_STOCK_OPTIONS_SUCCESS';
export const FETCH_STOCK_OPTIONS_FAIL = 'FETCH_STOCK_OPTIONS_FAIL';

export const SELECT_PLANT_ID = 'SELECT_PLANT_ID';

export const GET_SETTINGS_PLANT_STORAGE_TIME = 'GET_SETTINGS_PLANT_STORAGE_TIME';
export const GET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS = 'GET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS';
export const GET_SETTINGS_PLANT_STORAGE_TIME_FAIL = 'GET_SETTINGS_PLANT_STORAGE_TIME_FAIL';

export const SET_SETTINGS_PLANT_STORAGE_TIME = 'SET_SETTINGS_PLANT_STORAGE_TIME';
export const SET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS = 'SET_SETTINGS_PLANT_STORAGE_TIME_SUCCESS';
export const SET_SETTINGS_PLANT_STORAGE_TIME_FAIL = 'SET_SETTINGS_PLANT_STORAGE_TIME_FAIL';

export const SEND_FILE_STOCK_SETTINGS = 'SEND_FILE_STOCK_SETTINGS';
export const SEND_FILE_STOCK_SETTINGS_SUCCESS = 'SEND_FILE_STOCK_SETTINGS_SUCCESS';
export const SEND_FILE_STOCK_SETTINGS_FAIL = 'SEND_FILE_STOCK_SETTINGS_FAIL';

export const STATUS_FILE_STOCK_SETTINGS = 'STATUS_FILE_STOCK_SETTINGS';
export const STATUS_FILE_STOCK_SETTINGS_SUCCESS = 'STATUS_FILE_STOCK_SETTINGS_SUCCESS';
export const STATUS_FILE_STOCK_SETTINGS_FAIL = 'STATUS_FILE_STOCK_SETTINGS_FAIL';
